module.exports = __webpack_public_path__ + "media/images/flags/16/Puerto-Rico-a23f3f9ca65e871e24c54227341f7e57.png";